import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import * as Actions from 'actions';
import * as Permissions from 'permissions';
import Classnames from 'classnames';
import { connect } from 'react-redux';
import moment from 'moment';
import { Container, SidebarLeft, ContainerLoader, ClientDetails } from '../';
import { Row, Col } from 'react-bootstrap';

class ClientContainer extends React.Component {
  constructor(props) {
    super(props);
  }
  state = {
    deleting: false
  }
  componentWillMount() {
    this.props.fetchFields('Client');
    this.props.fetchClient(this.props.params.id);
  }
  componentWillUpdate(nextProps, nextState) {
    if(
      nextProps.params.id &&
      this.props.params.id != nextProps.params.id
    ) {
      this.props.fetchClient(nextProps.params.id);
    }
  }

  render() {
    if(!this.props.client._id) {
       return (<ContainerLoader/>);
    }
    const { deleting } = this.state;
    const { address, name, phone, last_updated, _id, date_added } = this.props.client;

    const menuItems = [{
      label: 'Dashboard',
      path: `client/${_id}`,
      iconClass: 'fa fa-dashboard'
    }, {
      label: 'Damage Incidents',
      path: `client/${_id}/incidents`,
      iconClass: 'fa fa-exclamation-triangle'
    }];

    if(this.props.hasPermission(Permissions.VIEW_OPPORTUNITIES)) {
      menuItems.push({
        label: 'Opportunities',
        path: `client/${_id}/jobs`,
        iconClass: 'fa fa-wrench'
      });
    }
    return (
      <Container title={`Client - ${name}`}>
        <SidebarLeft title="Client">
          <ClientDetails client={this.props.client}>
            <div className="widget-content">
              <ul className="list-unstlyed mg-folders">
                {menuItems.map((item, idx) =>
                  <li key={idx}>
                    <Link activeClassName="nav-active" className="menu-item" to={item.path}><i className={item.iconClass}></i> {item.label}</Link>
                  </li>
                )}
              </ul>
              <Row className="mt-sm">
                <Col xs={12}>
                  {deleting ? (
                    <div className="btn-group btn-group-block">
                      <div onClick={e => this.setState({deleting: false})} className="btn btn-default"><i className="fa fa-close"></i></div>
                      <div onClick={e => this.props.deleteClient(this.props.client)} className="btn btn-danger"><i className="fa fa-trash"></i> Are you sure?</div>
                    </div>
                  ) : (
                    <div onClick={e => this.setState({deleting: true})} className="btn btn-danger btn-block"><i className="fa fa-trash"></i> Delete</div>
                  )}
                </Col>
                <hr />
              </Row>
            </div>
          </ClientDetails>
        </SidebarLeft>
        {this.props.children}
      </Container>
    );
  }
}

const mapStateToProps = ({client}) => ({client});

export default connect(mapStateToProps, Actions)(ClientContainer);



// WEBPACK FOOTER //
// ./src/browser/components/client/client-container.js